<template>
  <v-app>
    <LoadingComp></LoadingComp>

    <HeaderComp v-if="exibir_header_footer" />

    <v-main class="background mt-2">
      <v-container fluid>
        <router-view />
      </v-container>
    </v-main>

    <FooterComp v-if="exibir_header_footer" />
  </v-app>
</template>

<script>
import HeaderComp from '@/components/templates/HeaderComp'
import FooterComp from '@/components/templates/FooterComp'
import verifica_autenticado from '@/utils/verifica_autenticado'
import LoadingComp from './components/LoadingComp';

export default {
  name: 'App',

  components: {
    HeaderComp,
    FooterComp,
    LoadingComp,
  },

  methods: {
    verifica_auth() {
      if(this.$route.path !== '/'){
        if(verifica_autenticado()) {
          return true;
        } else {
          this.$router.push('/')
        }
      } else {
        return false
      }
    }
  },

  computed: {
    exibir_header_footer() {
      const rota = this.$route.meta.headerFooter;
      return rota;
    },
  },
};
</script>

<style>
.v-data-table-header {
  background-color: #6f6f6f  !important;
}

.v-data-table-header > tr > th > i {
  color: white  !important;
}

.v-data-table-header > tr > th > span {
  color: white  !important;
}

.elevation-1 tbody tr:nth-of-type(odd) {
  background-color: #64595923 !important;
}

.elevation-1 tbody tr:nth-of-type(odd):hover {
  background-color: #514747a1 !important;
}

.elevation-1 tbody tr:nth-of-type(even):hover {
  background-color: #514747a1 !important;
}
</style>
